const aboutData = {
    title: "ZUBAIDE, BORN IN MALAYSIA IN 1982, IN HULU TERENGGANU",
    content: `
            Studied at Maahad Tahfiz Al-Quran Negeri Terengganu, later pursuing further studies in Information Technology. Now a passionate designer and developer, actively involved in various media platforms, book publishing, advertising, as well as mobile app and web development.
  `,
    image: "/images/me.png"
};

export default aboutData;
